<template>
    <div class="modal-alert-success">
        <div class="modal-alert">
            <span class="modal-alert-success-tip"></span>
            <span class="modal-alert-success-long"></span>
            <div class="modal-alert-success-ring"></div>
            <div class="modal-alert-success-fix"></div>
        </div>
        <div class="modal-alert-text"><slot></slot></div>
    </div>
</template>

<script>
export default {};
</script>
